import { LOGOUT_CALLBACK_ROUTE } from "@stadium/services/auth0";
import { BASE_PATH } from "@constants/app-defaults";

export const logoutCommonParams = (asPath) => {
  return {
    client_id: null,
    returnTo: window.location.origin + BASE_PATH + LOGOUT_CALLBACK_ROUTE + `?returnTo=${asPath}`,
  };
};
